export const hotelSmokingTypes = {
  noSmoking: "禁煙",
  smoking: "喫煙",
};
